import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ModalController} from "@ionic/angular";
import {VetClinic} from "../../models/vet-clinic.model";
import {AppStateService} from "../../providers/app-state.service";
import {VetClinicService} from "../../providers/vet-clinic.service";
import {Subscription} from "rxjs";
import {CommonUtils} from "../../utils/common";
import {Client} from "../../models/client.model";
import {ClientsService} from "../../providers/clients.service";

@Component({
  selector: 'app-sms-settings-modal',
  templateUrl: './sms-settings-modal.component.html',
  styleUrls: ['./sms-settings-modal.component.scss'],
})
export class SmsSettingsModalComponent implements OnInit, OnDestroy {

  @Input() title: string;
  @Input() uuid: string;
  @Input() type: 'CLINIC' | 'CLIENT';
  vetClinic: VetClinic;
  vClient: Client;
  vetClinicSub: Subscription;
  sendersSub: Subscription;
  isLoading: boolean = true;
  enableSMSSerwer: boolean;
  smsSerwerUser: string;
  smsSerwerPassword: string;
  pwdType: string = 'password';
  showPwdIcon: string = 'eye-off-outline';
  senders: string[];
  senderSelected: string;
  showSenders: boolean = false;
  smsProvider: string = 'SERWER_SMS';
  apiKey: string;

  constructor(private modalController: ModalController,
              private appStateService: AppStateService,
              private vetClinicService: VetClinicService,
              private vClientService: ClientsService,
              private commonUtils: CommonUtils) {
  }

  ngOnInit() {
    this.isLoading = true;
    if (this.type === 'CLINIC') {
      this.vetClinicSub = this.vetClinicService.getSpecificVetClinic(this.uuid).subscribe(e => {
        this.vetClinic = e;
        this.enableSMSSerwer = this.vetClinic.enableSMSSerwer;
        if (this.enableSMSSerwer) {
          this.smsSerwerUser = this.vetClinic.smsSerwerUser;
          this.smsSerwerPassword = this.vetClinic.smsSerwerPwd;
          this.senderSelected = this.vetClinic.smsSerwerSender;
          this.apiKey = this.vetClinic.smsApiKey;
          this.smsProvider = this.vetClinic.smsProvider;
          if (this.smsProvider === 'SERWER_SMS'  || this.smsProvider === 'SMS_PLANET') {
            this.sendersSub = this.vetClinicService.getSenders(this.uuid).subscribe(response => {
              this.senders = response;
              this.showSenders = true;
              this.isLoading = false;
            }, error => {
              this.isLoading = false;
              if (error.message == 'SENDERS_NOT_EXISTS' && this.vetClinic?.smsSerwerPwd) {
                if (this.smsProvider==='SERWER_SMS') {
                  this.commonUtils.presentInfoToast('Brak nadawców do wyboru, uzupełnij te informacje w SerwerSMS');
                } else {
                  this.commonUtils.presentInfoToast('Brak nadawców do wyboru, uzupełnij te informacje w SMS Planet');
                }
                this.showSenders = true;
              }
            });
          } else {
            this.showSenders = false;
            this.isLoading = false;
          }
        } else {
          this.showSenders = false;
          this.isLoading = false;
        }
      }, error => {
        this.isLoading = false;
      });
    } else {
      this.vetClinicSub = this.vClientService.getClientByUUID(this.uuid).subscribe(e => {
        this.vClient = e;
        this.enableSMSSerwer = this.vClient.enableSMSSerwer;
        if (this.enableSMSSerwer) {
          this.smsSerwerUser = this.vClient.smsSerwerUser;
          this.smsSerwerPassword = this.vClient.smsSerwerPwd;
          this.senderSelected = this.vClient.smsSerwerSender;
          this.sendersSub = this.vClientService.getSenders(this.uuid).subscribe(response => {
            this.senders = response;
            this.showSenders = true;
            this.isLoading = false;
          }, error => {
            this.isLoading = false;
            if (error.message == 'SENDERS_NOT_EXISTS' && this.vClient?.smsSerwerPwd) {
              this.commonUtils.presentInfoToast('Brak nadawców do wyboru, uzupełnij te informacje w SerwerSMS');
              this.showSenders = true;
            }
          });
        } else {
          this.showSenders = false;
          this.isLoading = false;
        }
      }, error => {
        this.isLoading = false;
      });


    }


  }

  onClose() {
    this.modalController.dismiss(null);
  }

  onSubmit() {
    if ((this.smsSerwerUser && this.smsSerwerPassword) || this.apiKey) {
      this.appStateService.updateIsBusySubject(true);

      if (this.type === 'CLINIC') {
        this.vetClinicService.updateSMSSerwerCredentials(this.vetClinic.uuid, this.smsSerwerUser, this.smsSerwerPassword, this.senderSelected, this.enableSMSSerwer, this.smsProvider, this.apiKey).subscribe(e => {
          this.appStateService.updateIsBusySubject(false);
          if (e) {
            if (this.smsProvider === 'JUST_SEND') {
              this.commonUtils.presentInfoToast('Dane do Just Send zostały zapisane poprawnie');
              this.modalController.dismiss(null);
            } else {
              if (this.showSenders) {
                if (this.smsProvider)

                this.commonUtils.presentInfoToast('Dane do Serwer SMS zostały zapisane poprawnie');
                this.modalController.dismiss(null);
              } else {
                this.commonUtils.presentInfoToast('Wybierz nazwę nadawcy z listy');
                this.sendersSub = this.vetClinicService.getSenders(this.uuid).subscribe(response => {
                  this.senders = response;
                  this.showSenders = true;
                  this.isLoading = false;
                }, error => {
                  this.showSenders = true;
                  this.isLoading = false;
                  if (error.message == 'SENDERS_NOT_EXISTS' && this.vetClinic.smsSerwerPwd) {
                    this.commonUtils.presentInfoToast('Zdefinuj w SerwerSMS dane nadawcy');
                  }
                });
              }
            }
          } else {
            this.commonUtils.presentAlertToast('Wystąpił błąd, nie można zapisać danych do usług SMS');
          }
        }, error => {
          this.commonUtils.presentAlertToast('Wystąpił błąd, nie można zapisać danych do usług SMS');
          this.appStateService.updateIsBusySubject(false);
        });
      } else {
        this.vClientService.updateSMSSerwerCredentials(this.vClient.uuid, this.smsSerwerUser, this.smsSerwerPassword, this.senderSelected, this.enableSMSSerwer).subscribe(e => {
          this.appStateService.updateIsBusySubject(false);
          if (e) {
            if (this.showSenders) {
              this.commonUtils.presentInfoToast('Dane do Serwer SMS zostały zapisane poprawnie');
              this.modalController.dismiss(null);
            } else {
              this.commonUtils.presentInfoToast('Wybierz nazwę nadawcy z listy');
              this.sendersSub = this.vetClinicService.getSenders(this.uuid).subscribe(response => {
                this.senders = response;
                this.showSenders = true;
                this.isLoading = false;
              }, error => {
                this.showSenders = true;
                this.isLoading = false;
                if (error.message == 'SENDERS_NOT_EXISTS' && this.vClient.smsSerwerPwd) {
                  this.commonUtils.presentInfoToast('Zdefinuj w SerwerSMS dane nadawcy');
                }
              });
            }
          } else {
            this.commonUtils.presentAlertToast('Wystąpił błąd, nie można zapisać danych do Serwera SMS');
          }
        }, error => {
          this.commonUtils.presentAlertToast('Wystąpił błąd, nie można zapisać danych do Serwera SMS');
          this.appStateService.updateIsBusySubject(false);
        })


      }
    }
  }

  ngOnDestroy(): void {
    if (this.vetClinicSub) {
      this.vetClinicSub.unsubscribe();
    }
  }

  saveDisabled() {
    if (this.smsProvider === 'SERWER_SMS') {
      return this.enableSMSSerwer && (!this.smsSerwerUser || !this.smsSerwerPassword);
    } else {
      return this.enableSMSSerwer && !this.apiKey;
    }
  }

  onChangePwdType() {
    if (this.pwdType === 'password') {
      this.pwdType = 'text';
      this.showPwdIcon = 'eye-outline';
    } else {
      this.pwdType = 'password';
      this.showPwdIcon = 'eye-off-outline';
    }
  }

  getTitleText() {
    return this.enableSMSSerwer ? 'Edytuj ustawienia Serwer SMS' :
      'Aktywowanie Serwer SMS pozwala na przesyłanie wiadomości SMS przy wysyłaniu linków do płatności';
  }

  getShowSenders() {
    return this.showSenders;
  }

  translateSenderName(sender: string) {
    if (sender && sender === '2waySMS') {
      return 'Losowy numer (domyślny)';
    } else {
      return sender;
    }

  }
}
